import React from 'react';
import cx from 'classnames';

export type ToggleCardProps = {
    children?: React.ReactNode | React.ReactNode[];
    isActive?: boolean;
    id?: string;
};

const ToggleCard: React.FC<ToggleCardProps> = (props) => {
    const componentRef = React.useRef<HTMLLIElement>(null);
    const { id, isActive, children } = props;
    const classname = cx({
        'toggle-card': true,
        'is-active': isActive,
    });

    React.useEffect(() => {
        if (isActive) {
            // trick for mobile devices
            setTimeout(() => {
                componentRef?.current?.scrollIntoView({
                    // behavior: 'smooth',
                    block: 'start',
                });
            }, 200);
        }
    }, [isActive]);

    return (
        <li className={classname} ref={componentRef} id={id}>
            {children}
        </li>
    );
};

export default ToggleCard;
